<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <span class="pageSteps card-styling">
        <p style="font-weight: 300; font-style: normal">Postagens</p>
        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Detalhes</p>
      </span>
      <section
        style="
          background-color: var(--white);
          box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
          border-radius: 12px;
          padding: 24px 24px;
          margin-top: 32px;
          width: 100%;
        "
        class="d-flex flex-column justify-content-between"
      >
        <section class="row">
          <div class="d-flex w-100 session-one">
            <div
              class="col-lg-12 col-12 card-styling justify-content-between d-flex flex-column"
              style="padding: 0"
            >
              <div class="col-12">
                <div class="d-flex session-one">
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">
                      <img
                        :src="require('@/assets/images/svg/icone-coracao.svg')"
                        class="img-fluid"
                        style="margin-right: 4px"
                      />Curtidas
                    </p>
                    <h2 class="text-center h2-card">0</h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Comentários</p>
                    <h2 class="text-center h2-card">0</h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">
                      <img
                        :src="require('@/assets/images/svg/icone-salvar.svg')"
                        class="img-fluid"
                        style="margin-right: 4px"
                      />Salvos
                    </p>
                    <h2 class="text-center h2-card">0</h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">
                      <img
                        :src="require('@/assets/images/svg/icone-share.svg')"
                        class="img-fluid"
                        style="margin-right: 4px"
                      />Compartilhamento
                    </p>
                    <h2 class="text-center h2-card">0</h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Alcance</p>
                    <h2 class="text-center h2-card">0</h2>
                  </div>
                  <div
                    class="col-lg-2 col-12 col-md-6 justify-content-between d-flex flex-column"
                  >
                    <p class="text-center p-card">Impressões</p>
                    <h2 class="text-center h2-card">0</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr style="border-color: #d3e7fb; width: 100%" />
        <section>
          <div class="session-one" style="display: flex; width: 100%">
            <img
              v-if="item.mediaType === 'IMAGE'"
              style="
                text-shadow: 1px 1px 2px #333;
                max-width: 600px;
                width: 100%;
                height: auto;
              "
              :src="item.mediaUrl"
              class="img-fluid d-block w-100 img-responsivo"
              alt=""
            />

            <div
              v-if="
                item.mediaType === 'CAROUSEL' ||
                item.mediaType === 'CAROUSEL_ALBUM'
              "
              id="carouselExampleControls"
              class="carousel slide"
              data-bs-interval="false"
              style="
                text-shadow: 1px 1px 2px #333;
                max-width: 600px;
                width: 100%;
                height: auto;
              "
            >
              <div class="carousel-inner">
                <div
                  v-for="(photos, index) in item.instagramMediaContainers"
                  :key="photos.id"
                  class="carousel-item"
                  :class="index === 0 ? 'active' : ''"
                >
                  <img
                    :src="photos.mediaUrl"
                    class="img-fluid d-block w-100 img-responsivo"
                    alt=""
                  />
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
            <video
              v-if="item.mediaType == 'VIDEO'"
              :src="item.mediaUrl"
              style="
                text-shadow: 1px 1px 2px #333;
                max-width: 400px;
                width: 400px;
              "
            ></video>
            <div style="margin-left: 32px">
              <section
                class="d-flex flex-column justify-content-between align-items-start w-100"
              >
                <h4
                  style="
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    color: #80848a;
                  "
                >
                  Publicação
                </h4>

                <div
                  class="d-flex justify-content-between align-items-center w-100 col-md-12"
                >
                  <div
                    class="d-flex justify-content-between align-items-center col-md-8"
                  >
                    <span class="d-flex justify-content-between flex-column">
                      <p
                        style="
                          font-style: normal;
                          font-weight: 400;
                          font-size: 14px;
                          color: #80848a;
                          margin: 0;
                        "
                      >
                        Loja
                      </p>
                      <p
                        style="
                          font-style: normal;
                          font-weight: 500;
                          font-size: 16px;
                          color: #383838;
                          margin: 0;
                        "
                      >
                        {{ item.instagramPage.pageName }}
                      </p>
                    </span>
                  </div>
                  <span style="margin-left: 10%">
                    <p
                      style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        color: #80848a;
                        margin: 0;
                      "
                    >
                      Data
                    </p>
                    <p
                      style="
                        font-style: normal;
                        font-weight: 500;
                        font-size: 16px;
                        color: #383838;
                        margin: 0;
                      "
                    >
                      {{ currentDate }}
                    </p>
                  </span>
                  <span style="margin-left: 10%">
                    <p
                      style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        color: #80848a;
                        margin: 0;
                      "
                    >
                      Horário
                    </p>
                    <p
                      style="
                        font-style: normal;
                        font-weight: 500;
                        font-size: 16px;
                        color: #383838;
                        margin: 0;
                      "
                    >
                      {{ currentHorario }}
                    </p>
                  </span>
                </div>
              </section>
              <section style="margin-top: 10%">
                <h4
                  style="
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    color: #80848a;
                  "
                >
                  Descrição
                </h4>
                <span>
                  <p style="font-weight: 500; font-size: 16px; color: #383838">
                    {{ item.caption }}
                  </p>
                </span>
              </section>
            </div>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment/moment";
import Loading from "vue-loading-overlay";
import apiGerenciarMidiasService from "../service/apiGerenciarMidiasService";

export default {
  name: "DetailsScheduled",
  components: { Loading },
  data() {
    return {
      item: [
        {
          instagramMediaContainers: [
            {
              mediaType: "",
            },
          ],
          instagramPage: {
            pageName: "",
          },
        },
      ],
      isReponder: false,
      slide: 0,
      text: "",
      comentarios: [],
      isLoading: false,
    };
  },
  async created() {
    this.isLoading = true;

    try {
      const response = await apiGerenciarMidiasService.getAllMedias({
        byId: true,
        id: this.$route.params.id,
      });

      if (response.status === 200) {
        this.item = response.data.data[0];
      }
    } catch (error) {
      console.log(error);
    }
    this.isLoading = false;
  },
  methods: {
    ...mapActions(["getDetailsAgendada"]),
  },
  computed: {
    currentDate() {
      return moment(this.item.scheduleDate).format("DD/MM/YYYY");
    },
    currentHorario() {
      let time = new Date(this.item.scheduleDate);
      time.setHours(time.getHours() - 3);
      return moment(time).format("hh:mm");
    },
  },
};
</script>
<style scoped>
.p-card {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.p-comentario {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.btn-card {
  color: #2485ea;
  border: none;
  border-radius: 8px;
  background: #d3e7fb;
  padding: 8px 25%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
}

.input-comentario {
  align-items: flex-start;
  padding: 12px 16px;
  background: #f0f2f8;
  border-radius: 4px;
  width: 100%;
  height: 43px;
  border: none;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #383838;
}

.h2-card {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
}
</style>
